var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cellphone-input"},[_c('vue-tel-input',{ref:"input",attrs:{"placeholder":_vm.placeholder,"defaultCountry":_vm.defaultCountry,"inputOptions":{
      tabindex: 1
    },"dropdownOptions":{
      tabindex: 999
    }},on:{"onInput":_vm.handleInput},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }